import { hideMinicart } from "@self/utils";
import { makeStylesheetLink } from "../../stylesheet";
import remove from "@self/images/remove";

export class ContinueShopping extends HTMLElement {

	shadow: ShadowRoot;

	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = (
			<button
				type="button"
				className="gct-btn-lg gct-btn-tertiary gct-w100"
				innerHTML={remove}
				>
			</button>
		) as HTMLButtonElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			this.button,
			makeStylesheetLink()
		);
	}

	connectedCallback() {
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

function onClick(this: ContinueShopping) {
	hideMinicart();
}
